/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2017 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

/* eslint-disable */

import { isIE, isEdge } from "./UserAgentsUtils";

const getDigest = ((arrayBuffer) => {
    if (isIE()) {
        return window.msCrypto.subtle.digest("SHA-256", arrayBuffer);
    }
    else if(window.crypto && window.crypto.subtle) {
      return window.crypto.subtle.digest("SHA-256", arrayBuffer);
    }
    else {
      return Promise.reject("Crypto is not supported");
    }
});

const getDigestHex = ((buffer) => {
    const byteArray = new Uint8Array(buffer);

    const hexCodes = [...byteArray].map((value) => {
        const hexCode = value.toString(16);
        const paddedHexCode = hexCode.padStart(2, "0");
        return paddedHexCode;
    });

    return hexCodes.join("");
});

const stringToUint8ArrayBuffer = ((str) => {
    let Len = 0;
    let resPos;
    let resArr;
    let point;
    let nextcode;
    let i;
    if (str) {
        Len = str.length;
        resPos = -1;
        resArr = typeof Uint8Array === "undefined" ? new Array(Len * 1.5) : new Uint8Array(Len * 3);
        for (point = 0, nextcode = 0, i = 0; i !== Len;) {
            point = str.charCodeAt(i);
            i += 1;
            if (point >= 0xd800 && point <= 0xdbff) {
                if (i === Len) {
                    resArr[(resPos += 1)] = 0xef;
                    resArr[(resPos += 1)] = 0xbf;
                    resArr[(resPos += 1)] = 0xbd;
                    break;
                }
                nextcode = str.charCodeAt(i);
                if (nextcode >= 0xdc00 && nextcode <= 0xdfff) {
                    point = ((point - 0xd800) * 0x400) + ((nextcode - 0xdc00) + 0x10000);
                    i += 1;
                    if (point > 0xffff) {
                        resArr[(resPos += 1)] = (0x1e << 3) | (point >>> 18);
                        resArr[(resPos += 1)] = (0x2 << 6) | ((point >>> 12) & 0x3f);
                        resArr[(resPos += 1)] = (0x2 << 6) | ((point >>> 6) & 0x3f);
                        resArr[(resPos += 1)] = (0x2 << 6) | (point & 0x3f);
                    }
                } else {
                    resArr[(resPos += 1)] = 0xef;
                    resArr[(resPos += 1)] = 0xbf;
                    resArr[(resPos += 1)] = 0xbd;
                }
            }
            if (point <= 0x007f) {
                resArr[(resPos += 1)] = (0x0 << 7) | point;
            } else if (point <= 0x07ff) {
                resArr[(resPos += 1)] = (0x6 << 5) | (point >>> 6);
                resArr[(resPos += 1)] = (0x2 << 6) | (point & 0x3f);
            } else {
                resArr[(resPos += 1)] = (0xe << 4) | (point >>> 12);
                resArr[(resPos += 1)] = (0x2 << 6) | ((point >>> 6) & 0x3f);
                resArr[(resPos += 1)] = (0x2 << 6) | (point & 0x3f);
            }
        }
        if (typeof Uint8Array !== "undefined") {
            return resArr.subarray(0, resPos + 1);
        }
        // else IE 6-9
        resArr.length = resPos + 1; // trim off extra weight
        return resArr;
    }
    return "";
});

export const getSHA256Digest = buffer =>
    new Promise((resolve, reject) => {
        if (isIE()) {
            const arrayBuffer = stringToUint8ArrayBuffer(buffer);
            let data = "";
            const operation = getDigest(arrayBuffer);
            operation.process(arrayBuffer);
            operation.finish();
            operation.oncomplete = function onComplete() {
                data = operation.result;
                if (data !== null) {
                    const documentHex = getDigestHex(data);
                    resolve(documentHex);
                } else {
                    reject("documentIdHash error");
                }
            };
        } else {
            const arrayBuffer = isEdge() ? stringToUint8ArrayBuffer(buffer) : new TextEncoder().encode(buffer);
            getDigest(arrayBuffer)
                .then((digestBuffer) => {
                    const documentHex = getDigestHex(digestBuffer);
                    resolve(documentHex);
                }).catch((err) => {
                    reject(err);
                });
        }
    });
